import { render, staticRenderFns } from "./Gaines1.vue?vue&type=template&id=53528fc5&scoped=true"
import script from "./Gaines1.vue?vue&type=script&lang=ts"
export * from "./Gaines1.vue?vue&type=script&lang=ts"
import style0 from "./Gaines1.vue?vue&type=style&index=0&id=53528fc5&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53528fc5",
  null
  
)

export default component.exports